import React from 'react';

export default function TrusonaFull() {
  return (
    <svg width={130} height={22}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M59.4 13.338V4.52h2.397v8.818c0 3.044-2.266 5.002-4.888 5.002s-4.907-1.958-4.907-5.002V4.52h2.435v8.818c0 1.581 1.16 2.61 2.472 2.61 1.31 0 2.49-1.029 2.49-2.61z"
          fill="#19064E"
        />
        <path
          d="M66.276 14.168c.038.988.843 1.917 2.23 1.917 1.291 0 2.078-.711 2.134-1.64.056-.91-.524-1.503-1.78-1.859l-1.591-.434c-2.81-.87-3.259-2.59-3.259-3.796 0-2.393 1.967-3.994 4.345-3.994 2.435 0 4.289 1.562 4.289 4.112h-2.397c0-1.067-.73-1.779-1.93-1.779-1.067 0-1.928.632-1.928 1.601 0 .435.15 1.167 1.536 1.562l1.591.494c2.884.83 3.634 2.55 3.521 4.152-.112 2.451-2.172 3.855-4.532 3.855-2.753 0-4.626-1.858-4.626-4.191h2.397zM99.207 18.142h-2.192l-4.981-8.956v8.956h-2.379V4.52h2.229l4.925 8.857V4.52h2.398z"
          fill="#7B46D1"
        />
        <path
          d="M80.981 4.34c-3.635 0-6.58 3.11-6.58 6.947s2.945 6.947 6.58 6.947c3.635 0 6.581-3.11 6.581-6.947 0-3.836-2.946-6.947-6.58-6.947m0 2.55c2.296 0 4.164 1.973 4.164 4.397 0 2.424-1.868 4.397-4.165 4.397-2.296 0-4.165-1.973-4.165-4.397 0-2.424 1.869-4.396 4.165-4.396"
          fill="#7B46D1"
          fillRule="nonzero"
        />
        <path
          fill="#19064E"
          d="M28.887 4.52h9.683v2.313h-3.634v11.309H32.52V6.833h-3.633zM46.587 13.2c2.285-.396 3.277-2.314 3.277-4.271 0-2.215-1.273-4.409-4.12-4.409h-5.17v13.622h2.398V6.774h2.66c1.198 0 1.741 1.166 1.741 2.155 0 1.008-.562 2.115-1.817 2.115h-1.424v2.522l2.866 4.576h2.885l-3.296-4.943z"
        />
        <path
          fill="#7B46D1"
          d="M104.285 14.84l-1.18 3.302h-2.547L105.39 4.52h2.585l4.831 13.622h-2.528l-1.18-3.302h-3.689l.783-2.214h2.12l-1.63-5.2-1.592 5.2z"
        />
        <path
          d="M18.125 9.349h-5.039v9.245h-2.63a1.752 1.752 0 0 1-1.757-1.758V9.349H5.415c-.998 0-1.755-.81-1.755-1.758V4.953h12.71c.965 0 1.755.791 1.755 1.759v2.637zm-12.71-.88h11.821v-.883H4.527c0 .435.338.884.888.884zm5.916 9.246h.878V9.349h-.878v8.366zm-1.755-.88c0 .55.46.88.878.88V9.349h-.878v7.487zM16.37 5.833H4.537v.88h12.708a.876.876 0 0 0-.875-.88zM10.893 0C4.877 0 0 4.886 0 10.913c0 6.026 4.877 10.912 10.893 10.912 6.015 0 10.892-4.886 10.892-10.912C21.785 4.886 16.908 0 10.893 0z"
          fill="#7B46D1"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/icons/TrusonaFull/index.js